import styles from "./TicketDescription.module.scss";
import ArrowBackIcon from "../../../styles/icon/arrow_back_fill.svg";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { ticketText } from "../../../actions/ticketText";
import {
  convertToPersian,
  convertToPersianWithTime,
} from "../../../utils/convertMoment";
import { LoadingPage } from "../../LoadingPage/LoadingPage";
import { successMessage } from "../../../utils/messages";

////ERRORS HANDLES
import {
  checkFileTypeImage,
  checkTicketDescription,
} from "../../Validator/Validator";
import { ERROR_CODE8, ERROR_CODE9 } from "../../Validator/ErrorCodes";
import { repliesToTicket } from "../../../services/userServices";
import { clearTicketText } from "../../../actions/ticketText";

export default function TicketDescription() {
  const history = useHistory();
  const data = useSelector((state) => state.ticketText);
  const loadingBar = useSelector((state) => state.loadingBar.loading);
  const { id } = useParams();
  const dispatch = useDispatch();
  //Get ticket data
  useEffect(() => {
    dispatch(ticketText(id));
    return () => dispatch(clearTicketText());
  }, [id]);
  const [answerTicket, setAnswerTicket] = useState({
    textArea: "",
    attachedFile: "",
  });
  const [handleError, setHandleError] = useState({
    text: "",
    pic: "",
    active: false,
  });
  const handleAnswerTicket = async (e) => {
    e.preventDefault();
    if (!checkTicketDescription(answerTicket.textArea))
      return setHandleError({ ...handleError, text: ERROR_CODE8 });
    if (answerTicket.attachedFile) {
      if (!checkFileTypeImage(answerTicket.attachedFile.name))
        return setHandleError({ ...handleError, text: ERROR_CODE9 });
    }

    try {
      setHandleError({ ...handleError, active: true });
      let data = new FormData();
      data.append("ticketId", id);
      data.append("body", answerTicket.textArea);
      if (!answerTicket.attachedFile) {
        const { status } = await repliesToTicket(data, false);
        if (status === 200) {
          successMessage("پاسخ ثبت شد");
          dispatch(ticketText(id));
          setAnswerTicket({ ...answerTicket, attachedFile: "", textArea: "" });
        }
      } else {
        data.append("file", answerTicket.attachedFile);
        const { status } = await repliesToTicket(data, true);
        if (status === 200) {
          successMessage("پاسخ ثبت شد");
          dispatch(ticketText(id));
          setAnswerTicket({ ...answerTicket, attachedFile: "", textArea: "" });
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setHandleError({ ...handleError, active: false });
    }
  };
  return (
    <>
      {loadingBar && <LoadingPage />}

      <div className={styles.container}>
        <div className={styles.back_icon}>
          <img
            src={ArrowBackIcon}
            alt="BACK"
            width={15}
            height={15}
            onClick={() => history.goBack()}
            className="convertPicToWhite"
          />
        </div>
        <div className={`font_color_white ${styles.title_of_page}`}>
          متن تیکت
        </div>
        <div className={` changeBackgroundToWhite ${styles.main}`}>
          <div className={styles.info_of_ticket}>
            <div className={styles.item_info_ticket}>
              <div>شماره:</div>
              <div>{data?.ticket?.id}</div>
            </div>
            <div className={styles.item_info_ticket}>
              <div>عنوان:</div>
              <div>{data?.ticket?.title}</div>
            </div>
            <div className={styles.item_info_ticket}>
              <div>دپارتمان:</div>
              <div>
                {data?.ticket?.department === "SALES"
                  ? "مالی (برداشت و واریز)"
                  : data?.ticket?.department === "TECH"
                  ? "پشتیبانی فنی"
                  : "پشتبانی عمومی"}
              </div>
            </div>
            <div className={styles.item_info_ticket}>
              <div>تاریخ:</div>
              <div>{convertToPersian(data?.ticket?.createdAt)}</div>
            </div>
            <div
              className={`${styles.item_info_ticket} ${styles.status_ticket_bg}`}
            >
              <div>وضعیت:</div>
              <div>
                {data?.ticket?.status === "UNCHECKED"
                  ? "بررسی نشده"
                  : data?.ticket?.status === "WAITING"
                  ? "در حال بررسی"
                  : data?.ticket?.status === "ANSWERED"
                  ? "پاسخ داده شده"
                  : data?.ticket?.status === "USER_ANSWERED"
                  ? "پاسخ کاربر"
                  : "بسته شده"}
              </div>
            </div>
          </div>
          <main className={styles.messages_of_ticket}>
            <div
              key={data?.ticket?.text + new Date()}
              className={`${styles.user_answer}`}
            >
              <div className={styles.description_message}>
                <p>{data?.ticket?.text}</p>
              </div>
              <div className={styles.line_}></div>
              <div className={styles.attached_files}>
                {data?.ticket?.details ? (
                  <>
                    <div>فایل پیوست:</div>
                    <div>
                      <div
                        onClick={() =>
                          window.open(
                            `https://arzfi.com/api/uploads/${data?.ticket?.details}`
                          )
                        }
                      >
                        {data?.ticket?.details?.length > 20
                          ? "..." + data?.ticket?.details?.slice(0, 20)
                          : data?.ticket?.details}
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
              <div className={styles.detail_message}>
                <div>پاسخ شما</div>
                <div>{convertToPersianWithTime(data?.ticket?.createdAt)}</div>
              </div>
            </div>
            {data?.replies?.map((rep) => (
              <div
                key={rep?.text + rep?.date}
                className={`${
                  rep?.type === "ADMIN"
                    ? styles.support_answer
                    : styles.user_answer
                }`}
              >
                <div className={styles.description_message}>
                  <p>{rep?.text}</p>
                </div>
                <div className={styles.line_}></div>
                <div className={styles.attached_files}>
                  {rep?.atached[0]?.file ? (
                    <>
                      <div>فایل پیوست:</div>
                      <div>
                        {rep?.atached?.map((r) => (
                          <div
                            key={r?.file + r?.file?.length}
                            onClick={() =>
                              window.open(
                                `https://arzfi.com/api/uploads/${r?.file}`
                              )
                            }
                          >
                            {r?.file?.length > 20
                              ? "..." + r?.file?.slice(0, 20)
                              : r?.file}
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div className={styles.detail_message}>
                  <div>{rep?.type === "USER" ? "پاسخ شما" : "پاسخ پشتبان"}</div>
                  <div>{convertToPersianWithTime(rep?.date)}</div>
                </div>
              </div>
            ))}
          </main>
          {data?.ticket?.status === "CLOSED" ? (
            ""
          ) : (
            <div className={styles.input_reply_to_ticket}>
              <form onSubmit={(e) => handleAnswerTicket(e)}>
                <textarea
                  placeholder="پاسخ تیکت"
                  onChange={(e) => {
                    setAnswerTicket({
                      ...answerTicket,
                      textArea: e.target.value,
                    });
                    setHandleError({ ...handleError, text: "" });
                  }}
                  value={answerTicket.textArea}
                ></textarea>
                <div className={styles.grid_system}>
                  <div className={styles.submit_btn}>
                    <button type="submit" disabled={handleError.active}>
                      ثبت پاسخ
                    </button>
                  </div>
                  <div className={styles.label_for_image}>
                    <input
                      type="file"
                      id="answer-ticket-user"
                      onChange={(e) =>
                        setAnswerTicket({
                          ...answerTicket,
                          attachedFile: e.target.files[0],
                        })
                      }
                    />
                    <label htmlFor="answer-ticket-user">
                      <div className={styles.upload_file}>پیوست فایل</div>
                    </label>
                    {answerTicket.attachedFile && (
                      <div
                        className={styles.clear_file}
                        onClick={() =>
                          setAnswerTicket({ ...answerTicket, attachedFile: "" })
                        }
                      >
                        پاک کردن فایل
                      </div>
                    )}
                  </div>
                </div>
                <div className={styles.handleErrors}>
                  <ul>
                    <li>{handleError.text}</li>
                    <li>{handleError.pic}</li>
                  </ul>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
